exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.portfolio-details[data-v-3fbf80d6] {\n  margin-bottom: 24px;\n  width: 100%;\n}\n.portfolio-details__description[data-v-3fbf80d6] {\n    border-bottom: 1px solid #2C3030;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fbf80d6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/portfolio/Portfolio.Details.vue
// module id = yOPZ
// module chunks = 1